/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_All_Caught_UpInputs */

const en_notifications_all_caught_up = /** @type {(inputs: Notifications_All_Caught_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're all caught up`)
};

const pl_notifications_all_caught_up = /** @type {(inputs: Notifications_All_Caught_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystko na bieżąco`)
};

/**
* | output |
* | --- |
* | "You're all caught up" |
*
* @param {Notifications_All_Caught_UpInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_all_caught_up = /** @type {((inputs?: Notifications_All_Caught_UpInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_All_Caught_UpInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_all_caught_up(inputs)
	return en_notifications_all_caught_up(inputs)
});